export default "__VITE_ASSET__DcwF248n__"